
let L = require('leaflet');
var layers = L.Control.Layers.extend({
    _onInputClick: function (Layer, name) {
        let controlDom = document.querySelector(".leaflet-control-layers-selector");
        let isChecked = controlDom.checked;
        let markers = this.options.markers;
        let overview = this.options.overview;
        let canvasLayer = this.options.canvasLayer;
        let map = this.options.map;
        if (isChecked) {
            console.log('markers.length',markers.length);
           canvasLayer.addLayers(markers);
        } else {
            for(let i = 0; i <markers.length; i++) {
                canvasLayer.removeMarker(markers[i],true);
            }
        }
    }
});

module.exports = {
    Layers: layers,
    layers: function (baseLayers, overlays, options) {
        return new layers(baseLayers, overlays, options);
    },
}; 